import {Request} from '@/apis'

export function page(params) {
    return Request.get("/jx/site/page", params);
}

export function getObj(id) {
    return Request.get("/jx/site/" + id);
}

export function findNearSite({lat, lon}) {
    return Request.get(`/jx/site/findNearSite?lat=${lat}&lon=${lon}`);
}

export function downloadModel() {
    return Request.download("/jx/site/downloadModel", {});
}

export function saveObj(obj) {
    return Request.post("/jx/site", obj);
}

export function updateObj(obj) {
    return Request.put("/jx/site", obj);
}

export function updateAndPushObj(obj) {
    return Request.put("/jx/site/updateAndPush", obj);
}

export function deleteObj(id) {
    return Request.delete("/jx/site/" + id);
}

export function uploadData(file) {
    let form = new FormData();
    form.append("file", file);
    return Request.upload("/jx/site/upload", form);
}

export function exportData(params) {
    return Request.export("/jx/site/export", params);
}
